import { ListOrdered } from 'lucide-react'

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { SequenceStatus } from '@/models/sequence'

const CONFIG: Partial<Record<SequenceStatus, { className: string; label: string }>> = {
  [SequenceStatus.RUNNING]: { className: 'text-blue-600', label: 'Sequence running' },
  [SequenceStatus.PAUSED]: { className: 'text-amber-500', label: 'Sequence paused' },
}

/** Small icon shown in the lead list when a lead has a live (running/paused) sequence. */
export function SequenceIndicator({ status }: { status: SequenceStatus | null }) {
  const config = status ? CONFIG[status] : undefined
  if (!config) return null
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={`${config.className} shrink-0`} aria-label={config.label}>
          <ListOrdered className="size-4" />
        </span>
      </TooltipTrigger>
      <TooltipContent>{config.label}</TooltipContent>
    </Tooltip>
  )
}
